



import { Vue, Component } from 'vue-property-decorator'
import Templates from '@/pages/Pages/Templates/Templates.vue';
import { MsgTransports } from '@/store/types';

@Component({components: {Templates}})
export default class CustomTemplates extends Vue {
  private transport: MsgTransports = MsgTransports.CUSTOM;
}
